/* eslint-disable @typescript-eslint/no-use-before-define */
import { Action, ActionReducerMap, StoreModule } from '@ngrx/store';
import { DisplayType } from '@polaris-customerweb/sharedcomponents.core';
import { DisplayAction, SetDisplayType } from './display.actions';

// This is definition of how state is stored/serialized in the store.
// TODO CC: make this interface look like DisplayMessage, and remove DisplayMessage
export interface DisplayState {
    displayType?: DisplayType;
}

const reducerMap: ActionReducerMap<DisplayState> = {
    displayType: displayTypeReducer,
};

// store module has to be added to the root of the module.
export const displayStoreModule = StoreModule.forFeature('display', reducerMap);

// Reducer takes a state and an action. And performs the action on that state.
// Return value of this reducer/function becomes the new state.
export function displayTypeReducer(
    state: DisplayType | undefined,
    action: Action
): DisplayType | undefined {
    switch (action.type) {
        case DisplayAction.setDisplayType:
            return (action as SetDisplayType).displayType;

        default:
            return state;
    }
}
